import React from 'react';
import { FeatureType } from '@types';
import CLinkSetting from '../customFeatureComponents/CLinkSetting';
import CMobileSetting from '../customFeatureComponents/CMobileSetting';
import CMapSetting from '../customFeatureComponents/CMapSetting';
import CMediaSetting from '../customFeatureComponents/CMediaSetting';
import CTextSetting from '../customFeatureComponents/CTextSetting';
import CAudioSetting from '../customFeatureComponents/CAudioSetting';
import CVideoSetting from '../customFeatureComponents/CVideoSetting';
import CSeqFrameSetting from '../customFeatureComponents/CSeqFrameSetting';
import CEventSetting from '../customFeatureComponents/CEventSetting';
import CArticleSetting from '../customFeatureComponents/CArticleSetting';
import { CMiniProgramSetting } from '../customFeatureComponents/CMiniProgramSetting';
import CDocSetting from '../customFeatureComponents/CDocSetting';
import CModel3dSetting from '../customFeatureComponents/CModel3dSetting';

interface Props {
  code: FeatureType;
}

/**
 * 热点, 自定义按钮, 图层的功能切换
 * 不包含场景切换, 场景切换在各个模块中单独处理
 * 上一场景/下一场景也是单独处理
 */
function FeatureSwitch({ code }: Props) {
  return (
    <>
      {code === FeatureType.link && <CLinkSetting />}
      {code === FeatureType.mobile && <CMobileSetting />}
      {code === FeatureType.map && <CMapSetting />}
      {code === FeatureType.media && <CMediaSetting />}
      {code === FeatureType.text && <CTextSetting />}
      {code === FeatureType.audio && <CAudioSetting isRequired />}
      {code === FeatureType.video && <CVideoSetting />}
      {code === FeatureType.seqFrame && <CSeqFrameSetting />}
      {code === FeatureType.event && <CEventSetting />}
      {code === FeatureType.article && <CArticleSetting />}
      {code === FeatureType.miniProgram && <CMiniProgramSetting />}
      {code === FeatureType.doc && <CDocSetting />}
      {code === FeatureType.model3d && <CModel3dSetting />}
    </>
  );
}

export default FeatureSwitch;
